import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { RoleType } from "../../../App/enums"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { RootState } from "../../../App/store"
import { CloseIcon, LockerIconSmall } from "../../Shared/Components/SvgIcons"
import { setModalData } from "../../Shared/SharedSlices/ModalSlice"
import { MembersType, setRoomMembers } from "../RoomSlices/MembersInRoomSlice"
import RadioButton from "../../Shared/Primitive/RadioButton"
import Button from "../../Shared/Primitive/Button"
import { getRoomRequest, updateMemberRoleRequest } from "../RoomServiceRequests/RoomServiceRequests"
import { setRoomData } from "../../Shared/SharedSlices/RoomSlice"

function RoomMemberRoleModal(props: {
    member: MembersType,
    roomId: number,
    currentRole: string
    memberType: RoleType
}) {
    const dispatch = useDispatch()
    const translation = useSelector(selectTranslations)

    const { roomId, id } = useParams()
    const Members = useSelector((state: RootState) => state.MembersInRoomSlice.members)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const roleMapping: Record<string, string> = {
        "manager": "Moderator:in",
        "moderator": "Moderator:in",
        "owner": "Gastgeber:in",
        "member": "Mitglied"
    }
    const [newRole, setNewRole] = useState<string>(props.currentRole)

    const onModalClose = () => {
        dispatch(setModalData({ open: false }))
    }

    const onRadioButtonClick = (selectedRole: string) => {
        switch (selectedRole) {
            case "manager":
                setNewRole("manager")
                break;
            case "moderator":
                setNewRole("manager")
                break;
            case "member":
                setNewRole("member")
                break
        }
    }

    const onSaveButtonClick = () => {
        updateMemberRoleRequest(props.roomId, {
            member_pk: props.member.id,
            member_type: props.memberType,
            new_role: newRole,
            organization_id: role === RoleType.ORGANIZATION ? Number(id) : undefined
        }).then((response) => {
            if (response.status === 200) {
                dispatch(setRoomMembers(Members.map((member) => {
                    if (member.id === props.member.id) {
                        return { ...member, room_role: newRole }
                    }
                    return member
                })))

                //refresh roomdata state
                getRoomRequest(parseInt(roomId!))
                    .then(response => {
                        if (response.status === 200) {
                            dispatch(setRoomData(response.data))
                        }
                    })

                dispatch(setModalData({ open: false }))
            }
        }).catch((error) => {
            console.log('Error updating member role')
        })
        return;
    }
    return (
        <div className="room-members-role-modal">
            <div className="room-members-role-modal__header">
                <div className="room-members-role-modal__text">
                    <div className="room-members-role-modal__mobile-icon">
                        <LockerIconSmall />
                    </div>
                    Rolle zuweisen
                </div>
                <div className="room-members-role-modal__close-icon room-members-role-modal__close-icon--mobile-icon" onClick={onModalClose}>
                    <CloseIcon />
                </div>
            </div>
            <div className="room-members-role-modal__content">
                <p>Aktuell ist {props.member.name} in diesem Raum <span className="room-members-role-modal__role-text">{roleMapping[props.currentRole] ?? props.currentRole}</span>.
                    Du kannst hier die Rolle des Mitglieds für den aktuellen Raum ändern.</p>
                <div className="room-members-role-modal__role-radio-buttons">
                    <div className="room-members-role-modal__role-radio-button">
                        <RadioButton modifier="radio__span--red" name="role" value={newRole === 'member'} onClick={() => onRadioButtonClick('member')} />
                        <p><span className="room-members-role-modal__role-text">{roleMapping['member']}</span>: Ein Mitglied dieses Raumes kann sich gemäß der von dir ermöglichten Rechte inhaltlich beteiligen. Administrative Rechte für diesen Raum bestehen hier nicht.</p>
                    </div>
                    <div className="room-members-role-modal__role-radio-button">
                        <RadioButton modifier="radio__span--red" name="role" value={newRole === 'manager'} onClick={() => onRadioButtonClick('moderator')} />
                        <p><span className="room-members-role-modal__role-text">{roleMapping['moderator']}</span>: Ein:e Moderator:in hat alle administrativen Rechte für diesen Raum. Hinweis: Im Gegensatz zur Admin-Rolle, hat die Moderator:in nicht zusätzliche administrative Rechte für das entsprechende Organisationsprofil</p>
                    </div>
                </div>
            </div>


            {props.currentRole === "moderator" && newRole !== "moderator" && Members.filter(m => m.room_role === "moderator").length === 1 ? (
                <div className="room-members-role-modal__error-message">
                    <p>Du kannst die Rolle nicht ändern, da {props.member.name} die einzige Moderator:in in diesem Raum ist. Bitte weise zuerst einem anderen Mitglied die Rolle des Moderators zu, bevor du die Rolle von {props.member.name} änderst.</p>
                </div>
            ) :
                <div className="room-members-role-modal__role-buttons">
                    <Button
                        type="submit"
                        className="button button--font-size-small button--font-weight-400 button--text-color-white button--color-gold button--hover-brighter button--cursor-pointer button--border-radius-05 room-members-role-modal__save-button"
                        onClick={() => onSaveButtonClick()}
                    >
                        <div>{translation.save}</div>
                    </Button>
                </div>}
        </div>
    )
}

export default RoomMemberRoleModal